import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AbouteMe.css';

export default function AbouteMe() {
  const navigate = useNavigate();

  return (
    <div className="aboute-wrapper">
      <main className="aboute-page container">
        {/* --- Menu Button --- */}
        <button className="menu-btn-ab" onClick={() => navigate('/')}>
          Menu
        </button>

        <h1 className="aboute-title">
          Շնորհակալ ենք, որ Ձեր տոները դարձնում ենք միասին՝ ջերմ, ուրախ և հիշվող պահեր ստեղծելով։
        </h1>

        <section className="aboute-section aboute-row">
          <div className="aboute-text">
            <p className="lead">
              Հյուրընկալելով Ձեզ 2020 թվականից այսօր՝ մենք դարձանք ավելի ընդարձակ և հարմարավետ Ձեր տոնական միջոցառումների համար:
            </p>
            <p>
              Ձեր շնորհիվ է, որ մենք կարողանում ենք պահպանել ընտանեկան ջերմ մթնոլորտ՝ յուրաքանչյուր հյուրի համար։
              Մեր նպատակն է՝ որպեսզի ձեր օրը լինի անուշ, ժպիտով լի և հիշարժան։
            </p>
          </div>
          <div className="aboute-image">
            <img src="/Images/celebration1.jpg" alt="Հյուրասիրություն" />
          </div>
        </section>

        <section className="aboute-section aboute-row reverse">
          <div className="aboute-image">
            <img src="/Images/celebration2.jpg" alt="Նոր սրահներ" />
          </div>
          <div className="aboute-text">
            <p>
              Ըստ Ձեր միջոցառումների ծավալի՝ այսօր մենք առաջարկում ենք տասը առանձնասրահ, որտեղ կարող եք անցկացնել
              փոքր միջոցառումներ՝ 10-12 կամ 25-30 հյուրերի համար։
            </p>
            <p>
              Երկու նոր սրահներ նախատեսված են 60-70 հյուրերի համար՝ օպտիմալ լուծում միջին կազմի միջոցառումների համար։
            </p>
          </div>
        </section>

        <section className="aboute-section aboute-row">
          <div className="aboute-text">
            <p className="highlight">
              Մեր "Կոլիզեյ" կոչվող սրահը նախատեսված է 160-180 հյուրերի համար, իսկ մեր մեծ հանդիսությունների սրահը պատրաստ է
              հյուրընկալել մինչև 400 հյուր։
            </p>
            <p>
              Մեզ մոտ դուք վայելում եք ոչ միայն թարմ և համեղ ուտեստներ, այլ նաև ստեղծում ջերմ և էսթետիկ հուշեր,
              որոնք կմնան ձեր և ձեր հյուրերի սրտում։
            </p>
          </div>
          <div className="aboute-image">
            <img src="/Images/celebration3.jpg" alt="Մեծ սրահ" />
          </div>
        </section>

        <section className="aboute-section final">
          <div className="aboute-image small">
            <img src="/Images/celebration4.jpg" alt="Սեղան" />
          </div>
          <div className="aboute-text small">
            <p>
              Մենք ուրախ ենք լինել Ձեր կողքին՝ օգնելով կազմել և իրականացնել այն միջոցառումը, որ ձեզ հարկավոր է։
              Կապվեք մեզ հետ՝ մանրամասները քննարկելու համար։
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
